RivalIQ.apps.Admin.module('collections', function (collections, Admin, Backbone, Marionette, $, _) {

    'use strict';

    collections.Companies = RivalIQ.collections.AtomicCollection.extend({
        model: Admin.models.Company,
        url: '/admin/api/companies',
        emptyMessage: function () {
            const me = this;
            if (!me.query || !me.query.length) {
                return 'You must enter something in the search field to get results';
            }

            return null;
        },

        preventEmptySearch: true,

        search: function (query) {
            const me = this;
            me.query = query;

            const options = {
                data: {
                    query: query,
                    limit: 100
                }
            };

            return me.fetch(options);
        },

        // A relatively naive sorting fn for relevancy.
        comparator: function (company) {
            const me = this;

            if (!me.query) {
                return company.get('id');
            }

            let value = 0;
            const name = company.get('name');
            const nameIndex = name.indexOf(me.query);
            if (nameIndex !== -1) {
                value -= me.query.length / name.length;
            } else {
                value += 1;
            }

            const url = company.get('source');
            const urlIndex = url.indexOf(me.query);
            if (urlIndex !== -1) {
                value -= me.query.length / url.length;
            } else {
                value += 1;
            }

            return value;
        },

        saveBulk: function (urls) {
            const me = this;

            // set the collection in the options hash so that the model's url
            // method will use the default behavior and pull urlBase out of the collection
            const model = new Backbone.Model({
                companyList: urls
            }, {
                collection: me
            });

            return (me.sync || Backbone.sync).call(me, 'create', model);
        }
    });
});
